
class GlossaryParser {

    constructor()
    {
        // @var Vue
        this.bus = null;
    }

    setBus(bus)
    {
        this.bus = bus;
    }

    init ()
    {
        this.parse(this.bus.$el);
    }

    parse (element)
    {
        const $element = $(element);

        if ($element.length >= 1)
        {
            $element.find('.gloss[data-gloss-go]:not(.has-listener)').each((index, element) =>
            {
                const $link = $(element);
                $link.addClass('has-listener');
                $link.on('click', () =>
                {
                    window.location.href = $link.data('gloss-go');
                });
            });

        }
    }
}

const glossaryParser = new GlossaryParser();
export { glossaryParser }



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/glossary-parser.js